import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import callDepartmentService from "../../services/api/CallDepartments";
import SuccessMessages from "../../constants/SucessMessages.json";
import { getPath, isValNull } from "../../utils";

function handleError(err) {
  console.log("error in Call Departments actions:", err);
}

export const setCallDepartmentList = (payload) => {
  return {
    type: ActionTypes.SET_CALL_DEPARTMENTS_LIST,
    payload,
  };
};

export const setCallDepartmentsActiveObject = (payload) => {
  return {
    type: ActionTypes.SET_CALL_DEPARTMENTS_ACTIVE_OBJECT,
    payload,
  };
};
export const setCallDepartmentsActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_CALL_DEPARTMENTS_ACTIVE_FILTERS,
    payload,
  };
};

export const setCallDepartmentLanguageRemoteSearch = (payload) => {
  return {
    type: ActionTypes.SET_CALL_DEPARTMENTS_LANGUAGE_REMOTE_SEARCH,
    payload,
  };
};

export const setCallDepartmentCurrentPage = (payload) => {
  return {
    type: ActionTypes.SET_CALL_DEPARTMENT_CURRENT_PAGE,
    payload,
  };
};

export const getCallDepartmentList =
  (pageNumber, filterObj) => async (dispatch) => {
    try {
      let filterBody = [];
      let activeFiltersObj = {};
      Object.keys(filterObj).map((key, index) => {
        if (!isValNull(filterObj[key])) {
          Object.assign(activeFiltersObj, { [key]: filterObj[key] });
          filterBody.push({
            key: key,
            value:
              typeof filterObj[key] === "string"
                ? `'${filterObj[key]}'`
                : `${filterObj[key]}`,
          });
        }
      });
      const body = {
        filters: filterBody,
        pageRequest: {
          page: pageNumber,
          pageSize: 20,
        },
      };
      dispatch(setLoader(true));
      const response = await callDepartmentService.getCallDepartmentsList(body);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setCallDepartmentCurrentPage(pageNumber));
        dispatch(setCallDepartmentList(response));
        dispatch(setCallDepartmentsActiveFilters(activeFiltersObj));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getCallDepartmentsDetails = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await callDepartmentService.getCallDepartmentDetails(id);
    dispatch(setLoader(false));
    if (response) {
      const obj = getPath(response, "department", {});
      dispatch(setCallDepartmentsActiveObject(obj));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const upsertCallDepartments = (body) => async (dispatch) => {
  try {
    // console.log(body);
    if (isValNull(body.id)) {
      delete body.id;
    }
    dispatch(setLoader(true));
    const response = await callDepartmentService.upsertCallDepartments(body);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: !body.id
            ? SuccessMessages.CREATION_SUCCESS
            : SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getCallDepartmentLanguageRemoteSearch =
  (startsWith, pageReq) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      if (Object.keys(startsWith).length === 0) {
        startsWith.startswith = "";
      }
      const response =
        await callDepartmentService.callDepartmentLanguageRemoteSearch(
          startsWith.startswith,
          pageReq.page ? pageReq.page : 1
        );
      dispatch(setLoader(false));
      if (response) {
        const data = getPath(response, "data", []);
        const appSupportedLanguages = [];
        for (let i = 0; i < data.length; i++) {
          if (getPath(data[i], "code", "").length > 0) {
            appSupportedLanguages.push(data[i]);
          }
        }
        response.data = appSupportedLanguages;
        dispatch(setCallDepartmentLanguageRemoteSearch(response));
        return response;
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
